import React from 'react';
import Navigation from '../../components/Nav/Nav';
import Accordion from 'react-bootstrap/Accordion';
import { Cta, Footer } from '../../LandingPage';
import { faqData } from './data';
import doodleGuyBuddha from '../../resources/doodle-guy-buddha.png';

const Faq = () => {
  return (
    <div className="tw-col-start-2 tw-col-end-12">
      <Navigation />
      {/* The inner column was sized at 90%/80% of whatever the viewport gave it,
          so the question rows grew without limit on a wide monitor. It is now a
          fixed measure centred in a padded card. */}
      <div className="tw-flex tw-justify-center tw-bg-neutral-50 tw-rounded-2xl tw-px-6 tw-py-12 sm:tw-px-10 lg:tw-px-16 tw-mt-24">
        <div className="tw-w-full tw-max-w-3xl tw-flex tw-flex-col tw-items-center tw-gap-6">
          {/* The eyebrow used to sit hard left under a centred title. */}
          <h3 className="tw-m-0 tw-text-sm tw-font-bold tw-bg-gradient-to-b tw-from-primary-400 tw-to-secondary-500 tw-bg-clip-text tw-text-transparent">
            FAQ
          </h3>
          <h2 className="tw-m-0 tw-text-3xl lg:tw-text-4xl tw-font-bold tw-text-center">Frequently Asked Questions</h2>
          <img
            src={doodleGuyBuddha}
            alt=""
            className="tw-w-full tw-max-w-sm tw-h-auto tw-object-contain"
          />
          <div className="tw-w-full">
            <Accordian />
          </div>
        </div>
      </div>
      <Cta />
      <Footer />
    </div>
  );
};

const Accordian = () => {
  return (
    <Accordion defaultActiveKey={[]} flush>
      {faqData.map((qa, i) => (
        <Accordion.Item key={i.toString()} eventKey={i.toString()}>
          <Accordion.Header>{qa.question}</Accordion.Header>
          <Accordion.Body className="tw-text-base tw-font-normal tw-text-primary-900">{qa.answer}</Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default Faq;
